import { styled, css } from '../../style';

const Styled = styled('div')(
  ({ theme }) => css`
    .account-button {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      border: 1px solid ${theme.colors.border};
      border-radius: ${theme.borderRadius};
      color: ${theme.colors.primaryText};
      font-size: 13px;
      font-weight: 600;
      letter-spacing: 1.2px;
      text-align: center;
      background-color: ${theme.colors.maximusDim};
      box-shadow: none;

      > .chain-name {
        padding: 0 ${theme.spacing2} 0 ${theme.spacing3};
        color: $grey200;
      }

      > .maximus-button {
        height: 32px;
        border-radius: ${theme.borderRadius};
        background: linear-gradient(
          90deg,
          #ffdc22 0%,
          #ffb90b 96.77%,
          #ffb600 96.77%
        );
        color: ${theme.black};
        cursor: pointer;
      }

      > .pending-loader-wrapper {
        height: 100%;
        padding: 0 $spacing3 0 ${theme.spacing2};
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        overflow-y: hidden;
        box-sizing: border-box;
        width: 72px;

        > .pending-loader {
          color: ${theme.colors.loading} !important;
          -webkit-animation: 2.5s linear infinite loaderRotate;
          -moz-animation: 2.5s linear infinite loaderRotate;
          animation: 2.5s linear infinite loaderRotate;
        }
      }
    }

    @-webkit-keyframes loaderRotate {
      from {
        transform: rotate(0deg);
      }
      to {
        transform: rotate(360deg);
      }
    }

    @-moz-keyframes loaderRotate {
      from {
        transform: rotate(0deg);
      }
      to {
        transform: rotate(360deg);
      }
    }

    @keyframes loaderRotate {
      from {
        transform: rotate(0deg);
      }
      to {
        transform: rotate(360deg);
      }
    }
  `
);

export default Styled;
